import { render } from "./Show.vue?vue&type=template&id=0234f511&lang=pug"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"
script.render = render

export default script